<template>
  <div>
    <template v-if="activity.description == 'login-enabled'">
      <LoginEnabled :activity="activity"></LoginEnabled>
    </template>

    <template v-else-if="activity.description == 'login-disabled'">
      <LoginDisabled :activity="activity"></LoginDisabled>
    </template>

    <template v-else-if="isVisited">
      <PageVisited :activity="activity"></PageVisited>
    </template>

    <template v-else-if="isEdited">
      <PageEdited :activity="activity"></PageEdited>
    </template>

    <template v-else-if="activity.description == 'submit-by-broker'">
      <SubmitByBroker :activity="activity"></SubmitByBroker>
    </template>

    <template v-else-if="activity.description == 'submit-by-client'">
      <SubmitByClient :activity="activity"></SubmitByClient>
    </template>

    <template v-else-if="activity.description == 'broker-logged-in'">
      <BrokerLoggedIn :activity="activity"></BrokerLoggedIn>
    </template>
  </div>
</template>

<script>

  import LoginEnabled     from "./activity-types/LoginEnabled";
  import LoginDisabled    from "./activity-types/LoginDisabled";
  import PageVisited      from "./activity-types/PageVisited";
  import PageEdited       from "./activity-types/PageEdited";
  import SubmitByBroker   from "./activity-types/SubmitByBroker";
  import SubmitByClient   from "./activity-types/SubmitByClient";
  import BrokerLoggedIn   from "./activity-types/BrokerLoggedIn";
  import { EventBus }     from '@/shared/event-bus';
  

  export default {

    props : {
      activity : {
        type    : Object,
        required: true
      },

      index : {
        type    : Number,
        required: true
      },
    },

    components : {
      LoginEnabled,
      LoginDisabled,
      PageVisited,
      PageEdited,
      SubmitByBroker,
      SubmitByClient,
      BrokerLoggedIn
    },

    computed : {
      isVisited() {
        return this.activity.description.indexOf("-visited") > -1
      },

      isEdited() {
        return this.activity.description.indexOf("-edited") > -1
      }
    }
  }
</script>

<style scoped>

</style>
